import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Theme, createTheme } from '@mui/material'
import { produce } from 'immer'

import {
  clearRequests,
  requestFailed,
  requestFinished,
  requestStarted,
} from './common.actions'
import { SocialMediaNetwork, Languages } from '@professocial/professocialTypes/types/commonTypes'
import { Message } from '@professocial/professocialTypes/types/messageTypes'
import { ActionCall } from '@professocial/professocialTypes/types'

export interface CommonState {
  theme: Theme
  user?: any
  language?: Languages[]
  socialMediaNetworks: SocialMediaNetwork
  message?: Message
  requests: ActionCall[]
}

const INITIAL_STATE: CommonState = {
  theme: createTheme(),
  socialMediaNetworks: {
    facebook: true,
  },
  requests: [],
}

const triggerProfessocialMessage = (data: Message) => {
  window.dispatchEvent(new CustomEvent('ProfessocialMessage', { detail: data }))
}

export const CommonReducer = reducerWithInitialState(INITIAL_STATE)
/**
   *  Requests Management
   */
  .case(requestStarted, (state, action) => {
    const clearStateRequests = state.requests.filter(request => request.status !== 'success')

    clearStateRequests.push({ type: action.type, status: 'pending', inProgress: true, error: null, id: action.id })
    return { ...state, requests: clearStateRequests }
  })
  .case(requestFinished, (state, action) => {
    return produce(state, (draft) => {
      const index = draft.requests.findIndex(request => request.type === action.type && request.id === action.id)
      if (index !== -1) {
        draft.requests[index].inProgress = false
        draft.requests[index].status = 'success'
        draft.requests[index].error = null
      }
      setTimeout(() => action.message && triggerProfessocialMessage({
        severity: action.message.severity,
        message: action.message.message,
        eventType: action.message.eventType,
      }))
    })
  })
  .case(requestFailed, (state, action) => {
    return produce(state, (draft) => {
      const index = draft.requests.findIndex(request => request.type === action.type)
      if (index !== -1) {
        draft.requests[index].inProgress = false
        draft.requests[index].status = 'failed'
        draft.requests[index].error = action.error
      }

      setTimeout(() => action.message && triggerProfessocialMessage({
        severity: action.message.severity,
        message: action.message.message,
        eventType: action.message.eventType,
      }))
    })
  })
  .case(clearRequests, (state) => {
    return produce(state, (draft) => {
      draft.requests = []
    })
  })
